import { createUseStyles } from 'react-jss';

import { theme } from '@align-cpf/uikit-styles';

const { colors, spacing } = theme;

export default createUseStyles(
  {
    input: {
      flex: '1 0 100%',
      width: '100%',
      padding: [spacing.sp03, spacing.sp04],
      border: 'none',
      boxSizing: 'border-box',
      borderRadius: spacing.sp01,
      outline: 'none',
      color: colors.textPrimary,
      font: theme.typography.tpBody01,
      backgroundColor: colors.backgroundSubtle01,
      boxShadow: [0, 0, 0, 1, 'transparent'],
      transition: 'box-shadow .2s ease-out',

      '&:focus-visible': {
        boxShadow: [0, 0, 0, 1, colors.borderFocus, 'inset'],
      },

      '&::placeholder': {
        color: colors.textTertiary,
        opacity: 1,
      },

      '&:disabled': {
        color: colors.textDisabled,
        pointerEvents: 'none',
      },

      '&:disabled&::placeholder': {
        color: colors.textDisabled,
      },
    },

    gray: {
      backgroundColor: colors.backgroundSubtle02,
    },

    error: {
      boxShadow: [0, 0, 0, 1, colors.borderError, 'inset'],
    },
  },
  {
    name: 'Input',
  },
);
